export default {
  state: {
    userInfo: null
  },
  getters: {},
  mutations: {
    setUserInfo(state, val) {
      state.userInfo = val;
    }
  },
  actions: {
    async getUserInfo({ commit, state }) {
      return new Promise(resolve => {
        if (state.userInfo && state.userInfo.userId > 0) {
          resolve(state.userInfo);
        } else {
          this.$axios.get("/app/api/user/details").then(res => {
            commit("setUserInfo", res.data);
            resolve(res.data);
          });
        }
      });
    }
  }
};
